import {PlatformCode} from '@dms/api/shared';

export type GetOlxPlatformApiResponse = /** status 200  */ OlxResponseBody;
export type OlxResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
};

export type DasWeltAutoCredentials = {
  username: string;
  password: string;
};
export type DasWeltAutoResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: DasWeltAutoCredentials | null;
};

export type SkodaPlusCredentials = {
  username: string;
  password: string;
};
export type SkodaPlusResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: SkodaPlusCredentials | null;
};

export type MyWebCredentials = {
  username: string;
  password: string;
};
export type MyWebDescriptionFormat = 'plain_text' | 'markdown' | 'html';

export type MyWebResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: MyWebCredentials | null;
  publishOnTenant: boolean;
  descriptionFormat?: MyWebDescriptionFormat;
};

export type MercedesNaSkladeCredentials = {
  dealerId: string;
};
export type MercedesNaSkladeResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: MercedesNaSkladeCredentials | null;
};

export type HyundaiPromiseCredentials = {
  username: string;
  password: string;
  dealerId: string;
};
export type HyundaiPromiseResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: HyundaiPromiseCredentials | null;
};

type AuthenticateRequestParams =
  | {
      branchId?: string;
    }
  | undefined;

export type GetDasWeltAutoPlatformApiResponse = /** status 200  */ DasWeltAutoResponseBody;
export type GetDasWeltAutoPlatformApiArg = {
  params: AuthenticateRequestParams;
};

export type GetSkodaPlusPlatformApiResponse = /** status 200  */ SkodaPlusResponseBody;
export type GetSkodaPlusPlatformApiArg = {
  params: AuthenticateRequestParams;
};

export type GetMyWebPlatformApiResponse = /** status 200  */ MyWebResponseBody;
export type GetMyWebPlatformApiArg =
  | {
      params: AuthenticateRequestParams;
    }
  | undefined;

export type GetMercedesNaSkladePlatformApiResponse =
  /** status 200  */ MercedesNaSkladeResponseBody;
export type GetMercedesNaSkladePlatformApiArg = {
  params: AuthenticateRequestParams;
};

export type GetHyundaiPromisePlatformApiResponse = /** status 200  */ HyundaiPromiseResponseBody;
export type GetHyundaiPromisePlatformApiArg = {
  params: AuthenticateRequestParams;
};

export type DasWeltAutoAuthenticateRequestBody = {
  username: string;
  password: string;
};
export type DasWeltAutoAuthenticateApiResponse = unknown;
export type DasWeltAutoAuthenticateApiArg = {
  body: DasWeltAutoAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type SkodaPlusAuthenticateRequestBody = {
  username: string;
  password: string;
};
export type SkodaPlusAuthenticateApiResponse = unknown;
export type SkodaPlusAuthenticateApiArg = {
  body: SkodaPlusAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type MyWebAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type UpdateMyWebDescriptionFormatApiResponse = unknown;
export type UpdateMyWebDescriptionFormatApiArg = {
  body: {descriptionFormat: MyWebDescriptionFormat};
  params:
    | {
        branchId?: string;
      }
    | undefined;
};
export type MyWebAuthenticateApiResponse = unknown;
export type MyWebAuthenticateApiArg = {
  body: MyWebAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type MercedesNaSkladeAuthenticateRequestBody = {
  dealerId: string;
};
export type MercedesNaSkladeAuthenticateApiResponse = unknown;
export type MercedesNaSkladeAuthenticateApiArg = {
  body: MercedesNaSkladeAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type HyundaiPromiseAuthenticateRequestBody = {
  username: string;
  password: string;
  dealerId: string;
};
export type HyundaiPromiseAuthenticateApiResponse = unknown;
export type HyundaiPromiseAuthenticateApiArg = {
  body: HyundaiPromiseAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type GetOtomotoPlatformApiResponse = /** status 200  */ OtomotoResponseBody;
export type GetOtomotoPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type OtomotoAuthenticateApiResponse = unknown;
export type OtomotoAuthenticateApiArg = {
  body: OtomotoAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type OtomotoCredentialsResponseBody = {
  username: string;
  password: string;
};
export type OtomotoResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: OtomotoCredentialsResponseBody | null;
};
export type OtomotoAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetFordUzywanePlatformApiResponse = /** status 200 */ FordUzywaneResponseBody;
export type GetFordUzywanePlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type FordUzywaneAuthenticateApiResponse = unknown;
export type FordUzywaneAuthenticateApiArg = {
  body: FordUzywaneAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type FordUzywaneCredentialsResponseBody = {
  username: string;
  password: string;
};
export type FordUzywaneResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: FordUzywaneCredentialsResponseBody | null;
};
export type FordUzywaneAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetAutoplacPlPlatformApiResponse = /** status 200 */ AutoplacPlResponseBody;
export type GetAutoplacPlPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type AutoplacPlAuthenticateApiResponse = unknown;
export type AutoplacPlAuthenticateApiArg = {
  body: AutoplacPlAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type AutoplacPlCredentialsResponseBody = {
  username: string;
  password: string;
};
export type AutoplacPlResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: AutoplacPlCredentialsResponseBody | null;
};
export type AutoplacPlAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetVehisPlatformApiResponse = /** status 200 */ VehisResponseBody;
export type GetVehisPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type VehisAuthenticateApiResponse = unknown;
export type VehisAuthenticateApiArg = {
  body: VehisAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type VehisCredentialsResponseBody = {
  username: string;
  password: string;
};
export type VehisResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: VehisCredentialsResponseBody | null;
};
export type VehisAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetMamGoPlatformApiResponse = /** status 200 */ MamGoResponseBody;
export type GetMamGoPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type MamGoAuthenticateApiResponse = unknown;
export type MamGoAuthenticateApiArg = {
  body: MamGoAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type MamGoCredentialsResponseBody = {
  username: string;
  password: string;
};
export type MamGoResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: MamGoCredentialsResponseBody | null;
};
export type MamGoAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetFordGeronimoPlatformApiResponse = /** status 200 */ FordGeronimoResponseBody;
export type GetFordGeronimoPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type FordGeronimoAuthenticateApiResponse = unknown;
export type FordGeronimoAuthenticateApiArg = {
  body: FordGeronimoAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type FordGeronimoCredentialsResponseBody = {
  username: string;
  password: string;
};
export type FordGeronimoResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: FordGeronimoCredentialsResponseBody | null;
};
export type FordGeronimoAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetSamochodyPlPlatformApiResponse = /** status 200 */ SamochodyPlResponseBody;
export type GetSamochodyPlPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type SamochodyPlAuthenticateApiResponse = unknown;
export type SamochodyPlAuthenticateApiArg = {
  body: SamochodyPlAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type SamochodyPlCredentialsResponseBody = {
  username: string;
  password: string;
};
export type SamochodyPlResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: SamochodyPlCredentialsResponseBody | null;
};
export type SamochodyPlAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type InputField = {
  name: string;
  title: string;
  type: string;
  sensitive: boolean;
  value: string;
};
export type Platform = {
  code: string;
  title: string;
  enabled: boolean;
  hasCredentials: boolean;
  credentials: InputField[];
  extraFields: InputField[];
};
export type UpdatePlatformRequest = {
  platformCode: PlatformCode;
  branchId?: string;
  enabled: boolean;
};

export type GetSautoPlatformApiResponse = /** status 200 */ SautoResponseBody;
export type GetSautoPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type SautoAuthenticateApiResponse = unknown;
export type SautoAuthenticateApiArg = {
  body: SautoAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type SautoCredentialsResponseBody = {
  username: string;
  password: string;
};
export type SautoResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: SautoCredentialsResponseBody | null;
};
export type SautoAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetTipcarsPlatformApiResponse = /** status 200 */ TipcarsResponseBody;
export type GetTipcarsPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type TipcarsAuthenticateApiResponse = unknown;
export type TipcarsAuthenticateApiArg = {
  body: TipcarsAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type TipcarsCredentialsResponseBody = {
  companyCode: string;
  password: string;
};
export type TipcarsResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: TipcarsCredentialsResponseBody | null;
  extraFields: Array<InputField>;
};
export type TipcarsAuthenticateRequestBody = {
  companyCode: string;
  password: string;
};

export type GetTipcarsClientDataApiResponse = /** status 200 */ TipcarsClientDataResponseBody;
export type GetTipcarsClientDataApiArg = {
  params: AuthenticateRequestParams;
};
export type TipcarsUpdateClientDataApiResponse = unknown;
export type TipcarsUpdateClientDataApiArg = {
  body: UpdateClientDataRequestBody;
  params: AuthenticateRequestParams;
};
export type TipcarsClientDataResponseBody = {
  companyName: string;
  address: string;
  postalCode: string;
  city: string;
  phone: string;
  fax: string;
  email: string;
  website: string;
  note: string;
};
export type UpdateClientDataRequestBody = {
  companyName: string;
  address: string;
  postalCode: string;
  city: string;
  phone: string;
  fax: string;
  email: string;
  website: string;
  note: string;
};

export type MobileDeOriginalCredentials = {
  sellerUsername: string;
  sellerPassword: string;
  sellerId: string;
} | null;
export type MobileDeCredentials = {
  username: string;
  password: string;
  sellerId: string;
};
export type MobileDeResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: MobileDeCredentials | null;
};
export type GetAdvertisingStatisticsApiResponse =
  /** status 200  */ AdvertisingStatisticsResponseBody;
export type AdvertisingPlatformCodeEnum =
  | 'sauto'
  | 'tipcars'
  | 'mobile.de'
  | 'myweb'
  | 'facebook'
  | 'autocaris'
  | 'otomoto'
  | 'olx'
  | 'skoda_plus'
  | 'das_weltauto'
  | 'mercedes_na_sklade'
  | 'mercedes_na_sklade_rest'
  | 'hyundai_promise'
  | 'ford_uzywane'
  | 'autoplac_pl'
  | 'vehis'
  | 'mamgo'
  | 'ford_geronimo'
  | 'samochody_pl'
  | 'findcar_pl'
  | 'autoscout24'
  | 'hexon'
  | 'toyota-ucl'
  | '2dehands'
  | 'luxauto'
  | 'mycar_lu'
  | 'vroom'
  | 'carflow'
  | 'tcs'
  | 'spoticar';
export type AdvertisementStatus =
  | 'not_published'
  | 'publishing'
  | 'publish_failed'
  | 'published'
  | 'updating'
  | 'update_failed'
  | 'unpublishing'
  | 'unpublish_failed';
export type AdvertisingStatusStatisticsResponseBody = {
  status: AdvertisementStatus;
  count: number;
};
export type AdvertisingPlatformStatisticsResponseBody = {
  platformCode: AdvertisingPlatformCodeEnum;
  statuses: AdvertisingStatusStatisticsResponseBody[];
};
export type AdvertisingStatisticsResponseBody = {
  inAdvertisementCount: number;
  platforms: AdvertisingPlatformStatisticsResponseBody[];
};
export type GetMobileDePlatformApiResponse = /** status 200  */ MobileDeResponseBody;
export type GetMobileDePlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type MobileDeAuthenticateRequestBody = {
  username: string;
  password: string;
  sellerId: string;
};
export type MobileDeAuthenticateApiResponse = unknown;
export type MobileDeAuthenticateApiArg = {
  body: MobileDeAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};

export type GetFacebookPlatformApiResponse = /** status 200  */ FacebookResponseBody;
export type GetFacebookPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type FacebookAuthenticateApiResponse = unknown;
export type FacebookAuthenticateApiArg = {
  body: FacebookAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type FacebookCredentialsResponseBody = {
  username: string;
  password: string;
};
export type FacebookResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: FacebookCredentialsResponseBody | null;
};
export type FacebookAuthenticateRequestBody = {
  username: string;
  password: string;
};

export type GetAutocarisPlatformApiResponse = /** status 200  */ AutocarisResponseBody;
export type GetAutocarisPlatformApiArg = {
  params: AuthenticateRequestParams;
};
export type AutocarisAuthenticateApiResponse = unknown;
export type AutocarisAuthenticateApiArg = {
  body: AutocarisAuthenticateRequestBody;
  params: AuthenticateRequestParams;
};
export type AutocarisCredentialsResponseBody = {
  username: string;
  password: string;
};
export type AutocarisResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: AutocarisCredentialsResponseBody | null;
};
export type AutocarisAuthenticateRequestBody = {
  username: string;
  password: string;
};
export type FindMatchApiResponse = /** status 200  */ FindMatchResponseBody[];
export type FindMatchApiArg = {
  platformCode?: AdvertisingPlatformCodeEnum;
  externalId?: string;
};
export type FindMatchResponseBody = {
  vehicleId: string;
  externalId: string;
  platformCode: AdvertisingPlatformCodeEnum;
  publishingBranchId: string | null;
};
export type GenerateDescriptionApiResponse = /** status 200  */ GenerateDescriptionResponseBody;
export type GenerateDescriptionApiArg = {
  vehicleId: string;
  body: GenerateDescriptionRequestBody;
};
export type GeneratedPlatformDescription = {
  platformCode: string;
  content: string;
  prompt: string;
  error: string | null;
};
export type GenerateDescriptionResponseBody = {
  content: string;
  prompt: string;
  platforms: GeneratedPlatformDescription[];
};
export type Language = 'cs' | 'en' | 'de' | 'es' | 'fr' | 'nl' | 'it' | 'pl' | 'sk';
export type GenerateDescriptionRequestBody = {
  language: Language | null;
  includeModel: boolean;
  includeEngine: boolean;
  includeFeatures: boolean;
  includeCondition: boolean;
  includeBranch: boolean;
  quickPresetIds: string[];
  length: number;
  mentionText: string | null;
  additionalInstruction: string | null;
};
export type GeneratePlatformDescriptionResponseBody = {
  content: string;
  prompt: string;
};
export type GeneratePlatformDescriptionApiResponse =
  /** status 200 */ GeneratePlatformDescriptionResponseBody;
export type GeneratePlatformDescriptionApiArg = {
  vehicleId: string;
  platformCode: string;
};
export type ConfirmGeneratedDescriptionsApiResponse = /** status 204 */ void;
export type ConfirmGeneratedDescriptionsApiArg = {
  vehicleId: string;
  body: ConfirmGeneratedDescriptionsRequestBody;
};
export type ConfirmGeneratedDescriptionsRequestBody = {
  description: string;
  platforms: Array<{
    platformCode: string;
    description: string;
  }>;
};
export type FindCarPlAuthenticateRequestBody = {
  username: string;
  password: string;
};
export type FindCarPlLinkResponseBody = {
  link: string;
};
export type FindCarPlCredentialsResponseBody = {
  username: string;
  password: string;
};
export type FindCarPlResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentials: FindCarPlCredentialsResponseBody | null;
};
export type FindCarPlAuthenticateApiResponse = /** status 204  */ void;
export type FindCarPlAuthenticateApiArg = {
  branchId?: string | null;
  findCarPlAuthenticateRequestBody: FindCarPlAuthenticateRequestBody;
};
export type GetFindCarPlLinkApiResponse = /** status 200  */ FindCarPlLinkResponseBody;
export type GetFindCarPlLinkApiArg = {
  branchId?: string | null;
};
export type GetFindCarPlApiResponse = /** status 200  */ FindCarPlResponseBody;
export type GetFindCarPlApiArg = {
  branchId?: string | null;
};
export type GetFindCarPlPlatformApiResponse = /** status 200  */ FindCarPlResponseBody;
export type GetFindCarPlPlatformApiArg = {
  branchId?: string | null;
};

export type PromptBridgeCredentialsSource = 'branch' | 'tenant' | null;
export type PromptBridgeCredentials = Record<string, unknown>;
export type PromptBridgePlatformResponseBody = {
  code: string;
  title: string;
  enabled: boolean;
  credentialsSource: PromptBridgeCredentialsSource;
  credentials: PromptBridgeCredentials | null;
  branchCredentialsAvailable: boolean;
  tenantCredentialsAvailable: boolean;
  tenantFallbackEnabled: boolean;
  canDeleteBranchOverride: boolean;
};
export type GetPromptBridgePlatformApiResponse = /** status 200 */ PromptBridgePlatformResponseBody;
export type GetPromptBridgePlatformApiArg = {
  platformCode: string;
  branchId?: string | null;
};
export type PromptBridgePlatformAuthenticateApiResponse = /** status 204 */ void;
export type PromptBridgePlatformAuthenticateApiArg = {
  platformCode: string;
  branchId?: string | null;
  body: PromptBridgeCredentials;
};
export type DeletePromptBridgePlatformBranchCredentialsApiResponse = /** status 204 */ void;
export type DeletePromptBridgePlatformBranchCredentialsApiArg = {
  platformCode: string;
  branchId: string;
};
